export const AUTH_USER_KEY = "sonne_auth_user_v1";
export const ROLE_KEY = "sonne_role_v1";
export const BIZ_SELECT_KEY = "sonne_business_selected_v1";
// Sichert den echten System-Admin-User, während er einen Mandanten impersoniert.
export const IMPERSONATION_ORIGIN_KEY = "sonne_impersonation_origin_v1";
